import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionActions,
  AccordionSummary,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PerButton from './PerButton';
import { useDispatch, useSelector } from 'react-redux';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import SelectDepHeadIdBottomSheet from './SelectDepHeadIdBottomSheet';
import { CommonActions } from '../../../Reducer/CommonReducer';
// import Icon from '../../../Assets/Icon/CustomIcon';

export default function WorkCheckList({
  SaveLogic1,
  SaveLogic2,
  codeList,
  rowData1,
  rowData3,
  userInfo,
  handleSignRequest,
  SearchLogic2,
  selectedDepHeadId,
  setSelectedDepHeadId,
  workTypes,
  ToggleDrawer: propsToggleDrawer,
}) {
  const dispatch = useDispatch();
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const ToggleDrawer =
    propsToggleDrawer ??
    ((anchor, open) => () => {
      dispatch(
        BottomSheetActions.SetBottomSheetState({
          bottom: open,
          type: bottomSheetState?.type,
        })
      );
    });
  const [expanded, setExpanded] = useState(0);
  const [answers, setAnswers] = useState({});
  const activeStep = useSelector((state) => state.common.activeStep);

  useEffect(() => {
    const allItems = Object.values(codeList || {}).flat();
    if (allItems.length > 0) {
      setExpanded(allItems[0].code);
    }
  }, [codeList]);
  useEffect(() => {
    if (rowData3?.length > 0) {
      const initialAnswers = {};
      rowData3.forEach((item) => {
        initialAnswers[item.WORK_TYPE_DTL] =
          item.ITEM_CHECK === '0' ? '확인' : '해당없음';
      });
      setAnswers(initialAnswers);
    }
  }, [rowData3]);

  const handleChange = (code) => (_, isExpanded) => {
    setExpanded(isExpanded ? code : false);
  };

  const handleAnswer = (code, answer) => {
    setAnswers((prev) => ({ ...prev, [code]: answer }));

    const allItems = Object.values(codeList).flat();
    const currentIndex = allItems.findIndex((item) => item.code === code);

    if (currentIndex !== -1 && currentIndex < allItems.length - 1) {
      setExpanded(allItems[currentIndex + 1].code);
    } else {
      setExpanded(false);
    }
  };

  const buttonStyle = (selected) => ({
    width: '48%',
    height: 36,
    borderRadius: '5px',
    backgroundColor: 'transparent',
    border: `1px solid ${selected ? '#7A5CFA' : '#D7D7D7'}`,
    color: selected ? '#7A5CFA' : '#D7D7D7',
    boxShadow:
      '0px 2px 3px -1px rgba(0,0,0,0.1), 0px 1px 0px 0px rgba(25,28,33,0.02), 0px 0px 0px 1px rgba(25,28,33,0.08)',
  });

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: 'easeOut', delay: 0.3 }}
    >
      <p>작업별 사전체크 항목을 선택해주세요.</p>
      <p style={{ fontSize: '16px', color: '#939393' }}>
        모든 항목을 선택해주세요.
      </p>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
          marginTop: 1,
          marginBottom: '16px',
        }}
      >
        {Object.entries(codeList).map(([groupCd, items]) => (
          <React.Fragment key={groupCd}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyItems: 'center',
                gap: '0.1rem',
              }}
            >
              {/* <Icon.Category /> */}
              <Typography
                sx={{
                  fontWeight: 'bold',
                  fontSize: '18px',
                  mt: 1,
                  color: '#eb6c1dff',
                }}
              >
                {workTypes?.find((wt) => wt.code === groupCd)?.codeNm ||
                  groupCd}
              </Typography>
            </div>

            {items.map((item) => {
              const selectedAnswer = answers[item.code];
              return (
                <Accordion
                  key={item.code}
                  expanded={expanded === item.code}
                  onChange={handleChange(item.code)}
                  sx={{
                    border: '1px solid',
                    borderColor: selectedAnswer ? '#7A5CFA' : '#D3D3D3',
                    borderRadius: '10px !important',
                    boxShadow: 'none',
                    '&::before': { display: 'none' },
                    '&.Mui-expanded': { margin: '8px 0px' },
                  }}
                >
                  <AccordionSummary
                    expandIcon={!selectedAnswer && <ExpandMoreIcon />}
                  >
                    <Typography
                      sx={{ fontWeight: 'bold', fontSize: '18px', flex: 1 }}
                    >
                      {item.codeNm}
                    </Typography>
                    {selectedAnswer && (
                      <Typography sx={{ color: '#7A5CFA', fontWeight: 'bold' }}>
                        {selectedAnswer}
                      </Typography>
                    )}
                  </AccordionSummary>

                  <AccordionActions
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      px: '16px',
                    }}
                  >
                    {['해당없음', '확인'].map((option) => (
                      <button
                        key={option}
                        style={buttonStyle(selectedAnswer === option)}
                        onClick={() => handleAnswer(item.code, option)}
                      >
                        {option}
                      </button>
                    ))}
                  </AccordionActions>
                </Accordion>
              );
            })}
          </React.Fragment>
        ))}
      </div>

      <PerButton
        cancelText="이전"
        onCancel={() => {
          dispatch(CommonActions.setActiveStep(activeStep - 1));
        }}
        onClick={() => {
          const allAnswered = Object.values(codeList)
            .flat()
            .every((item) => answers[item.code] !== undefined);

          if (!allAnswered) {
            dispatch(
              showSnackbar({
                message: '모든 항목을 체크해주세요.',
                type: 'warning',
              })
            );
            return;
          }

          dispatch(BottomSheetActions.SetBottomSheetState({ bottom: true, type: 'selectDepHeadId' }));
        }}
      />
      {/* 바텀시트 */}
      {bottomSheetState.bottom &&
        bottomSheetState.type === 'selectDepHeadId' && (
          <SelectDepHeadIdBottomSheet
            open={true}
            ToggleDrawer={ToggleDrawer}
            SearchLogic2={SearchLogic2}
            rowData1={rowData1}
            rowData3={rowData3}
            userInfo={userInfo}
            selectedDepHeadId={selectedDepHeadId}
            setSelectedDepHeadId={setSelectedDepHeadId}
            SaveLogic1={SaveLogic1}
            SaveLogic2={SaveLogic2}
            codeList={codeList}
            answers={answers}
            handleSignRequest={handleSignRequest}
          />
        )}
    </motion.div>
  );
}
